/**
 * @description
 *
 * Возвращает значение query параметра с текущего урла если он есть, либо undefined
 *
 * @returns {string | undefined} -
 */

function getQueryParam(paramName) {
  return new URLSearchParams(window.location.search).get(paramName)
}

export default getQueryParam
